module.exports = __webpack_public_path__ + "img/water6.2d412e48.jpg";